<template>
    <div>
        <list-page ref="appTable" :endpoint="`${apiCall}?`" :headers="headers" title="Vendors"
            :showActionsColumn="false" :showAddButton="isAllowed('createVendor')"
            :showEditButton="isAllowed('editVendor')" :showDeleteButton="isAllowed('deleteVendor')"
            :showViewButton="isAllowed('viewVendor')" @view="navigateTo(`/app/vendors/view/${$event._id}`)"
            @add="navigateTo('/app/vendors/0')" @edit="navigateTo(`/app/vendors/${$event._id}`)"
            @delete="deleteVendor($event._id)">
            <template v-slot:action="{ item }" v-if="$vuetify.breakpoint.smAndUp">
                <template v-for="icon in icons">
                    <action-button :key="icon.name" :icon="icon.name" :show="isAllowed(icon.permission)"
                        @click="icon.name == 'mdi-delete' ? deleteVendor(item._id) : $router.push(icon.path + '' + item._id)"></action-button>
                </template>
            </template>
            <template v-slot:createdAt="{ item }" v-if="$vuetify.breakpoint.smAndUp">
                {{ item.createdAt | dateFormat }}
            </template>
            <template v-slot:accountStatus="{ item }" v-if="$vuetify.breakpoint.smAndUp">
                <vendor-account-status :status="item.accountStatus"></vendor-account-status>
            </template>
            <template v-slot:item="{ item }" v-if="$vuetify.breakpoint.xsOnly">
                <simple-card :title="item.businessName" :subtitle="item.slug" :description="item.description"
                    :actions="icons" @view="navigateTo(`/app/vendors/view/${item._id}`)" :status="checkStatus(item.accountStatus)"
                    @edit="navigateTo(`/app/vendors/${item._id}`)" @delete="deleteVendor(item._id)"></simple-card>
                <!-- <vendor-card :id="item._id" :slug="item.slug" :name="item.businessName" :mobileNo="item.mobileNo" :email="item.email" :icons="icons" @delete="removeItem"></vendor-card> -->
            </template>
        </list-page>
        <!-- <page-header v-model="search" @input="find()" title="Vendors" permission="createVendor" @click="navigateTo('/app/vendors/0')"></page-header>
    <div>
        <v-data-table :headers="headers" :items="items" class="elevation-1" :items-per-page="items.length" :search="search" hide-default-footer>
            
        </v-data-table>
        <pagination :api="apiCall" v-model="items" sort="+createdAt"></pagination>
    </div> -->
    </div>
</template>

<script>
import ActionButton from '@/components/ActionButton'
import appConstants from '@/utils/appConstants'
import VendorCard from '@/components/UserResponsiveCard'
import VendorAccountStatus from '../../../components/VendorAccountStatus.vue';
import ListPage from '../../../components/common/ListPage.vue';
import SimpleCard from '../../../components/SimpleCard.vue';
export default {
    components: {
        ActionButton,
        VendorCard,
        VendorAccountStatus,
        ListPage,
        SimpleCard
    },
    data() {
        return {
            search: "",
            headers: [{
                text: "Business Name",
                value: "businessName"
            },
            {
                text: "Mobile Number",
                value: "mobileNo"
            },
            {
                text: "Email",
                value: "email"
            },
            {
                text: "Created On",
                value: "createdAt"
            },
            {
                text: "Status",
                value: "accountStatus"
            },
            {
                text: "Access Point",
                value: "slug"
            },
            {
                text: 'Actions',
                value: 'action',
                align: 'right'
            }
            ],
            search: '',
            items: [],
            icons: [{
                name: "mdi-eye",
                path: "/app/vendors/view/",
                permission: "viewVendor",
                event: 'view'
            }, {
                name: "mdi-pencil",
                path: "/app/vendors/",
                permission: "editVendor",
                event: 'edit'
            },
            {
                name: "mdi-delete",
                permission: "deleteVendor",
                event: 'delete'
            }
            ],
            apiCall: appConstants.VENDORS_API,
            loading: false,
        };
    },
    methods: {
        async deleteVendor(id) {
            try {
                await this.deleteItem("Are you sure you want to delete this Vendor?", appConstants.VENDORS_API + "/" + id)
                this.items.splice(this.items.findIndex(rec => rec._id == id), 1)
            } catch (error) {
                this.handleError(error)
            }
        },
        removeItem(id) {
            this.deleteVendor(id)
        },
        statusColor(status){
            return this.$refs.vendorStatus?.checkStatus(status) || 'PENDING'
        }
    }
};
</script>

<style scoped>
.format {
    padding: 1%;
}
</style>
